import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'


export default function () {
  return (
    <div>
      <LoadingOutlined style={{ fontSize: 40 }} />
    </div>
  )
}
